function renderReCaptcha(form, recaptchaWidget, callback) {
  grecaptcha.ready(function () {
    const widgetId = grecaptcha.render(recaptchaWidget, {
      size: 'invisible',
      badge: 'inline',
      callback: function () {
        callback(widgetId);
      },
      sitekey: recaptchaWidget.getAttribute('data-site-key'),
    });

    return widgetId;
  });
}
